<template>
	<div class="common-order-detail">
		<div>
		<div class="info-wraper">
		<div class="info-content">
			<!--卖家信息-->
			<div class='seller-info' v-if="order_info.extend_store">
				<div class='item'>
					<div class='content-flex'>
						<div class='flex-left name'><i class='pickup'>[{{ $t('distributor.dashboard.pickup') }}]</i>{{order_info.extend_store.store_name}}</div>
						<div class='flex-right phone' v-if="order_info.extend_store.store_phone">
                            <i class="cubeic-phone"></i>
                            <a :href="'tel:' + order_info.extend_store.store_phone">{{ order_info.extend_store.store_phone }}</a>
                        </div>
					</div>
				</div>
				<div class='item'>
					<div class='address'>{{order_info.extend_store.store_address}}</div>
				</div>
			</div>
			<!--买家信息-->
			<div class='buyer-info' v-if="order_info.extend_order_common">
				<div class='item'>
					<div class='content-flex'>
						<div class='flex-left name'><i class='deliver'>[{{ $t('distributor.dashboard.deliver') }}]</i>{{order_info.extend_order_common.reciver_name}}</div>
						<div class='flex-right phone' v-if="order_info.extend_order_common.reciver_info.mob_phone">
                            <i class="cubeic-phone"></i>
                            <a :href="'tel:' + order_info.extend_order_common.reciver_info.mob_phone">{{ order_info.extend_order_common.reciver_info.mob_phone }}</a>
                        </div>
					</div>
				</div>
				<div class='item'>
					<div class='address'>{{order_info.extend_order_common.reciver_info.address}} {{order_info.extend_order_common.reciver_info.floor}} {{order_info.extend_order_common.reciver_info.note}}</div>
				</div>
			</div>
		</div>
		</div>

		<!--购物清单-->
		<div class="info-wraper">
		<div class='info-header'>{{ $t('distributor.dashboard.order_list') }}</div>
		<div class="info-content" v-if="order_info.extend_order_goods">
			<div class='item' v-for="goods in order_info.extend_order_goods" :key="goods.goods_id">
				<div class='content-flex'>
					<div class='flex-left goods-info'><img class='goods-image' :src='goods.goods_image_url'><div class='goods-name'>{{goods.goods_name}}</div></div>
					<!-- <div class='flex-right goods-pay-price'>{{ goods.goods_price | moneyFilter }}</div> -->
					<div class='flex-right goods-count'>×{{goods.goods_num}}</div>
                    <!-- 等之後平台價與店內價功能完成後，再將其功能註解移除 2022/2/14 by afuz
					<cube-button v-if="isDeliverState && revisedGoodsIds.indexOf(goods.goods_id) === -1" :primary="true" class="editBtn" @click="handleReviseGoods(order_info.order_id, goods.goods_id)">修改</cube-button>
                    <span v-else-if="revisedGoodsIds.indexOf(goods.goods_id) > -1">已回報</span>
                    -->
				</div>
			</div>
		</div>
		</div>

		<!-- 修改 dialog -->
		<div class="modal" v-if="edit">
			<div class="modal-content">
				<h3 style="text-align: center; font-size: 15px; margin-bottom: 20px">修改訂單</h3>
				<cube-radio-group v-model="reviseGoods.action" :options="options" />
				<cube-input v-model="reviseGoods.new_price" style="width: 90%; margin-left: 15px;"
				placeholder="請輸入新價格..."></cube-input>
				<div style="display: flex; justify-content: center; align-items: center; margin-top: 20px">
					<div style="margin-right: 10px;">
						<cube-button :outline="true" class="cancelBtn" @click="cancelReviseGoods()">取消</cube-button>
					</div>
					<div>
						<cube-button :inline="true" @click="reviseGoodsNext()" :disabled="$v.reviseGoods.$invalid">下一步</cube-button>
					</div>
				</div>
			</div>
		</div>

		<!-- upload dialog -->
		<div class="modal" v-if="uploadDialog">
			<div class="modal-content">
				<h3 style="text-align: center; font-size: 15px">請上傳店家即時菜單照片</h3>
				<cube-upload ref="upload" v-model="reviseGoods.images" :auto="false">
					<div class="clear-fix uploadDiv">
						<cube-upload-btn :multiple="false">
							<div style="display: flex; flex-direction: column; justify-content: center; align-items: center;">
								<div class="addIcon">＋</div>
								<p>請上傳菜單照片</p>
							</div>
						</cube-upload-btn>
					</div>
					<cube-upload-file v-for="(file, i) in reviseGoods.images" :file="file" :key="i" style="margin-top: 10px;"></cube-upload-file>
				</cube-upload>

				<div style="display: flex; justify-content: center; align-items: center; margin-top: 20px">
					<div style="margin-right: 10px;">
						<cube-button :outline="true" @click="back()" class="cancelBtn">上一步</cube-button>
					</div>
					<div>
						<cube-button :inline="true" @click="uploadConfirm()" :disabled="$v.reviseGoods.$invalid">確認送出</cube-button>
					</div>
				</div>
			</div>
		</div>

		<!--總計金額-->
		<div class="info-wraper">
		<div class='info-header'>
			<div class="content-flex">
				<div class="flex-left">
					{{ $t('distributor.errand.on_behalf_amount') }}
					<span v-if="order_info.extend_order_common && order_info.extend_order_common.invoice_info.store_response == 'checked'"> ({{ $t('distributor.errand.invoice_status_checked') }})</span>
					<span v-else-if="order_info.extend_order_common && order_info.extend_order_common.invoice_info.store_response == 'none'"> ({{ $t('distributor.errand.invoice_status_none') }})</span>
				</div>
				<div class="flex-right">
					<cube-button v-if="isDeliverState && !isReported" :outline="true" :inline="true" :primary="true" @click="showReportDialog()">{{ $t('distributor.action.report_payment_amount') }}</cube-button>
                    <span v-else-if="isDeliverState && isReported" class='reported-payment-amount-text'>{{ $t('distributor.action.payment_amount_reported') }}</span>
				</div>
			</div>
		</div>
		<div class="info-content" v-if="order_info.goods_amount">
			<div class='item'>
				<div class='content-flex'>
					<div class='flex-left'>{{ $t('distributor.dashboard.total') }}</div>
					<div class='flex-right goods-total-amount'>{{ order_info.o2o_distributor_on_behalf_amount | moneyFilter }}</div>
				</div>
			</div>
		</div>
		</div>

		<!--用户备注-->
		<div class="info-wraper" v-if="order_info.extend_order_common && order_info.extend_order_common.order_message">
		<div class='info-header'>{{ $t('distributor.dashboard.buyer_message') }}</div>
		<div class="info-content">
			<div class='item'>
				<div class='address' v-html="orderMessage"></div>
			</div>
		</div>
		</div>

		<!--聯繫客服-->
		<div class="info-wraper">
		<div class='info-header'>{{ $t('chatroom.chat_with_admin') }}</div>
		<div class="info-content">
			<div class='item'>
				<div class='content-flex'>
					<div class='flex-left'></div>
					<div class='flex-right' style="position: relative;">
						<mt-button class='common-btn default' @click="openChatroom('admin')">{{ $t('chatroom.chat_with_admin') }}</mt-button>
                        <mt-badge v-if="unreadCount > 0" size="small" type="error" style="position: absolute; right: -0.2rem; top: -0.5rem;">{{ unreadCount }}</mt-badge>
					</div>
				</div>
			</div>
		</div>
		</div>

		<!--订单信息-->
		<div class="info-wraper">
		<div class='info-header'>{{ $t('distributor.dashboard.operation_time') }}</div>
		<div class="info-content">
			<div class='item' v-if="order_info.o2o_order_receipt_time">
				<div class='content-flex address'>
					<div class='flex-left'>{{ $t('distributor.dashboard.order_release_time') }}</div>
					<div class='flex-right'>{{$moment.unix(order_info.o2o_order_receipt_time).format('YYYY-MM-DD HH:mm')}}</div>
				</div>
			</div>
			<div class='item' v-if="order_info.o2o_order_deliver_time">
				<div class='content-flex address'>
					<div class='flex-left'>{{ $t('distributor.dashboard.order_occupy_time') }}</div>
					<div class='flex-right'>{{$moment.unix(order_info.o2o_order_deliver_time).format('YYYY-MM-DD HH:mm')}}</div>
				</div>
			</div>
			<div class='item' v-if="order_info.o2o_order_arrived_time">
				<div class='content-flex address'>
					<div class='flex-left'>{{ $t('distributor.dashboard.order_arrived_time') }}</div>
					<div class='flex-right'>{{$moment.unix(order_info.o2o_order_arrived_time).format('YYYY-MM-DD HH:mm')}}</div>
				</div>
			</div>
			<div class='item' v-if="order_info.o2o_order_pickup_time">
				<div class='content-flex address'>
					<div class='flex-left'>{{ $t('distributor.dashboard.order_pickup_time') }}</div>
					<div class='flex-right'>{{$moment.unix(order_info.o2o_order_pickup_time).format('YYYY-MM-DD HH:mm')}}</div>
				</div>
			</div>
			<!-- <div class='item'>
				<div class='content-flex address' v-if="order_info.o2o_order_pickup_time">
					<div class='flex-left'>取货时间</div>
					<div class='flex-right'>{{$moment.unix(order_info.o2o_order_pickup_time).format('YYYY-MM-DD HH:mm')}}</div>
				</div>
			</div> -->
			<div class='item' v-if="order_info.finnshed_time">
				<div class='content-flex address'>
					<div class='flex-left'>{{ $t('distributor.dashboard.order_successful_time')}}</div>
					<div class='flex-right'>{{$moment.unix(order_info.finnshed_time).format('YYYY-MM-DD HH:mm')}}</div>
				</div>
			</div>
		</div>
		</div>
		</div>
		<div class='btn pickup' v-if="order_info.order_state==OrderState.RECEIPT" @click=''>{{ $t('distributor.dashboard.op_occupy') }}</div>
		<div class='btn pickup' v-if="order_info.order_state==OrderState.OCCUPY" @click='arriveStore'>{{ $t('distributor.dashboard.op_arrived') }}</div>
		<div class='btn pickup' v-if="order_info.order_state==OrderState.DELIVER" @click='showBarcode'>{{ $t('distributor.dashboard.op_ready') }}</div>
		<div class='btn deliver' v-if="order_info.order_state==OrderState.SEND" @click='receiveOrder'>{{ $t('distributor.dashboard.op_receive') }}</div>

		<!-- Dialog - 回報付款金額 -->
		<cube-popup type="my-popup" position="top" ref="reportPaymentAmountDialog">
			<ReportPaymentAmount :order_id="order_info.order_id" @cancel="() => hiddenReportDialog()" @submit="() => handleReported()"></ReportPaymentAmount>
		</cube-popup>
	</div>
</template>

<script>
import { mapState, mapMutations, mapGetters } from 'vuex'
import { Toast, MessageBox } from 'mint-ui'
import { getOrderInfo, receiveOrder, arriveStore, pickupOrder } from '../../../api/distributorOrder'
import { OrderState, OrderGoodsRevisedRecordAction } from '@src/const/order'
import { moneyFilter } from '@src/util/filter'
import { createRevisedRecord, getRevisedRecordByOrderId } from '@src/api/orderGoodsRevisedRecord'
import { required, requiredIf, integer } from 'vuelidate/lib/validators'
import ReportPaymentAmount from './report_payment_amount'

export default {
	name: 'DistributorOrderDetail',
	components: { ReportPaymentAmount },
	validations: {
		reviseGoods: {
			action: {
				required,
				inArray: function (val) {
					return [OrderGoodsRevisedRecordAction.SOLD_OUT, OrderGoodsRevisedRecordAction.MODIFY_GOODS_PRICE].indexOf(val) > -1
				}
			},
			order_id: {
				required,
				integer
			},
			goods_id: {
				required,
				integer
			},
			new_price: {
				required: requiredIf(function (val) {
					return this.reviseGoods.action === OrderGoodsRevisedRecordAction.MODIFY_GOODS_PRICE
				})
			},
			images: {
				required: requiredIf(function (val) {
					return this.reviseGoods.action === OrderGoodsRevisedRecordAction.MODIFY_GOODS_PRICE && val.new_price && this.uploadDialog && !this.edit
				})
			}
		}

	},
	data () {
		return {
			popupVisible: false,
			order_info: {},
			OrderState: OrderState,
			options: [
				{
					label: '品項售完',
					value: OrderGoodsRevisedRecordAction.SOLD_OUT
				},
				{
					label: '輸入新價格',
					value: OrderGoodsRevisedRecordAction.MODIFY_GOODS_PRICE
				}
			],
			reviseGoods: {
				action: undefined,
				order_id: undefined,
				goods_id: undefined,
				new_price: undefined,
				images: []
			},
			revisedGoodsIds: [],
			edit: false,
			uploadDialog: false
		}
	},
	props: {
		order_id: {
			type: Number
		},
		unreadCount: {
			type: Number,
			required: false,
			default: 0
		}
	},
	filters: {
		moneyFilter
	},
	watch: {
		order_id: function (newOrderId, oldOrderId) {
			if (newOrderId) {
				getOrderInfo(newOrderId).then(res => {
					this.order_info = res.result.order_info
					this.revisedGoodsIds = []
					let _this = this
					getRevisedRecordByOrderId(this.order_info['order_id'])
						.then((res) => {
							_this.order_info['extend_revised_record'] = res.result
							res.result.forEach(element => {
								_this.revisedGoodsIds.push(element.goods_id)
							})
					        _this.$emit('update:order', _this.order_info)
						})
				}).catch(function (error) {
					Toast(error.message)
				})
			}
		}
	},
	created: function () {
	},
	computed: {
		...mapState({
			statistics: state => state.distributor.statistics
		}),
		orderMessage () {
			let msg = `${this.order_info.extend_order_common.pickup_message}%%${this.order_info.extend_order_common.order_message.replace(/^%%/, '')}`
			return msg.replace(/%%/g, '<br>')
		},
		isDeliverState () {
			return this.order_info.order_state === OrderState.DELIVER
		},
		isReported () {
			return !!this.order_info.extend_report_payment_amount
		}
	},
	methods: {
		...mapMutations({
			distributorStatistics: 'distributorStatistics',
			distributorOrderDetail: 'distributorOrderDetail'
		}),
		openChatroom (toClientType) {
			this.$emit('openChatroom', toClientType)
		},
		showReportDialog () {
			this.$refs.reportPaymentAmountDialog.show()
		},
		hiddenReportDialog () {
			this.$refs.reportPaymentAmountDialog.hide()
		},
		handleReported () {
			this.hiddenReportDialog()
		},
		initialReviseGoods () {
			this.reviseGoods = {
				action: undefined,
				order_id: undefined,
				goods_id: undefined,
				images: []
			}
		},
		cancelReviseGoods () {
			this.edit = false
			this.initialReviseGoods()
		},
		reviseGoodsNext () {
			this.edit = false
			if (this.reviseGoods.action === OrderGoodsRevisedRecordAction.SOLD_OUT) {
				this.soldOut()
			} else {
				this.uploadDialog = true
			}
		},
		soldOut () {
			const _this = this
			this.$createDialog({
				type: 'confirm',
				title: '因品項售完，依照顧客提示',
				content: '移除此商品',
				icon: 'cubeic-delete',
				onConfirm: function () {
					createRevisedRecord(_this.reviseGoods)
						.then((res) => {
							_this.$alert.success('已回報完成！')
							_this.initialReviseGoods()
						})
						.catch((err) => {
							_this.$alert.error(`錯誤! 請稍後再試. (${err.code}) ${err.message}`)
						})
				}
			}).show()
		},
		arriveStore () {
			arriveStore(this.order_id).then(res => {
				// Toast('操作成功')
				location.reload()
			}).catch(function (error) {
				Toast(error.message)
			})
		},
		pickupOrder () {
			MessageBox({
				title: this.$t('general.system_alert'),
				message: this.$t('distributor.dashboard.op_pickup_confirm') + '？',
				confirmButtonText: this.$t('general.confirm'),
				showCancelButton: true,
				cancelButtonText: this.$t('general.cancel')
			}).then(res => {
				console.log(res)
				if (res == 'confirm') {
					pickupOrder(this.order_id).then(res => {
						// Toast('操作成功')
					}).catch(function (error) {
						Toast(error.message)
					}).finally(() => {
						location.reload()
					})
				} else { location.reload() }
			})
		},
		receiveOrder () {
			MessageBox.prompt(this.$t('distributor.dashboard.op_receive_code'), '', {
				confirmButtonText: this.$t('general.confirm'),
				showCancelButton: true,
				cancelButtonText: this.$t('general.cancel'),
				closeOnClickModal: false
			}).then(({ value, action }) => {
				document.querySelector('.v-modal').remove()
				if (value) {
					receiveOrder(this.order_id, value).then(res => {
						// Toast('操作成功')
						// 更新今日统计信息
						this.distributorStatistics({ statistics: res.result.statistics })
						this.distributorOrderDetail(false)
						location.reload()
					}).catch(function (error) {
						Toast(error.message)
					})
				}
			}).catch(function (error) {
				document.querySelector('.v-modal').remove()
			})
		},
		showBarcode () {
			let invoice = this.order_info.extend_order_common.invoice_info
			let invoiceGateway = this.order_info.extend_order_common.invoice_gateway
			if (invoiceGateway && invoice.store_response == 'checked') {
				MessageBox({
					title: this.$t('distributor.dashboard.tax_id_number'),
					message: '<div class="common-alert-content" style="font-size: 1.7rem;">' + invoiceGateway.tax_code + '<div class="alert-notice" style="font-size: 0.7rem;">' + this.$t('distributor.dashboard.tax_id_note') + '</div></div>',
					confirmButtonText: this.$t('distributor.dashboard.op_pickup'),
					closeOnClickModal: false
				}).then(res => {
					this.pickupOrder()
				})
			} else {
				this.pickupOrder()
			}
		},
		uploadConfirm () {
			this.uploadDialog = false
			let data = Object.assign({}, this.reviseGoods)
			createRevisedRecord(data)
				.then((res) => {
					this.$alert.success('已回報完成！')
					this.initialReviseGoods()
				})
				.catch((err) => {
					this.$alert.error(`錯誤! 請稍後再試. (${err.code}) ${err.message}`)
				})
		},
		back () {
			this.uploadDialog = false
			this.edit = true
		},
		handleReviseGoods (order_id, goods_id) {
			this.edit = true
			this.reviseGoods = Object.assign({}, {
				order_id,
				goods_id
			})
		}
	}
}
</script>

<style scoped lang='scss'>
	.common-order-detail {
		top: 4.5rem;
		padding-bottom: 4rem;
	}
	.editBtn {
		background-color: #ffc90e;
    	color: black;
    	width: auto;
    	height: 20px;
    	padding: 3px;
    	margin: 0px;
    	margin-left: 20px;
    	font-size: 13px;
	}
	.modal {
		position: fixed;
		z-index: 1;
		left: 0;
		top: 0;
		display: flex;
		justify-content: center;
		align-items: center;
		width: 100%;
		height: 100%;
		overflow: auto;
		background-color: rgb(0,0,0);
		background-color: rgba(0,0,0,0.4);
	}

	.modal-content {
		background-color: #fefefe;
		margin: auto;
		padding: 20px;
		border: 1px solid #888;
		width: 80%;
		font-size: 13px;
	}
	.cancelBtn {
		height: auto;
    	padding: 9px 12px;
    	font-size: 13px;
	}
	.uploadDiv {
		padding: 10px;
    	text-align: center;
    	background: lightgrey;
    	margin-top: 20px;
    	border-radius: 5px;
	}
	.addIcon {
		background: darkgray;
    	border-radius: 50%;
    	padding: 20px;
    	height: 40px;
    	width: 40px;
    	font-size: 40px;
		margin-bottom: 15px;
	}
	.modal-content >>> .border-top-1px::before,
	.modal-content >>> .border-bottom-1px::before {
		display: none;
	}
	.modal-content >>> .border-bottom-1px::after {
		border-bottom: none;
	}

    .reported-payment-amount-text {
        font-size: .6rem;
        color: $descTextColor;
    }
</style>
